import ContactMessages from "../../components/admin/contact-messages/ContactMessages";
import AdminTemplate from "../../views/AdminTemplate";

const AdminContactMessagesPage = () => {
  return (
    <AdminTemplate>
      <ContactMessages />
    </AdminTemplate>
  );
};

export default AdminContactMessagesPage;
